import { supabase } from "../supabase";
import type { AvailabilityWindow } from "../types";

interface WindowRow {
  profile_id: string;
  from_time: string;
  to_time: string;
  reason: string;
}

function trimSeconds(t: string): string {
  return t.length > 5 ? t.slice(0, 5) : t;
}

export async function mapBySchool(schoolId: string): Promise<Record<string, AvailabilityWindow[]>> {
  const { data, error } = await supabase
    .from("availability_windows")
    .select("profile_id, from_time, to_time, reason, profiles!inner(school_id)")
    .eq("profiles.school_id", schoolId);
  if (error) throw error;
  const out: Record<string, AvailabilityWindow[]> = {};
  for (const r of (data ?? []) as (WindowRow & { profiles: unknown })[]) {
    const w: AvailabilityWindow = {
      from: trimSeconds(r.from_time),
      to: trimSeconds(r.to_time),
      reason: r.reason,
    };
    (out[r.profile_id] ||= []).push(w);
  }
  return out;
}
